import axios from "axios";
import { API_BASE_URL } from "../utils/config";

const updateMembershipFee = async (user, customerData, Id) => {
  try {
    if (!user) {
      throw {
        response: {
          data: {
            message: "User is not authenticated",
            type: "error",
          },
        },
      };
    }
    const idTokenResult = await user.getIdTokenResult();
    if (
      idTokenResult.claims.admin === true ||
      idTokenResult.claims.callCenter === true
    ) {
      const idToken = await user.getIdToken();
      const res = await axios.put(
        `${API_BASE_URL}api/updateMembershipFee/updateMembershipFee/${Id}`,
        customerData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
        }
      );
      return res;
    } else {
      throw {
        response: {
          data: {
            message: "User is not authorized",
            type: "error",
          },
        },
      };
    }
  } catch (error) {
    throw error;
  }
};

export default updateMembershipFee;
